// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-Navigation-DataExtractionNavigationItems-module__DataExtractionNavigationItems";
export { _1 as "DataExtractionNavigationItems" }
